import { MenuItem } from "@mui/material"
import { MRT_Row } from "material-react-table"
import { makeStyles } from "tss-react/mui"

import { ExternalServiceEntry } from "../extraServicesTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getExtraServiceRoute } from "../../../../../constants/routes"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { DefaultConfirmModalStateType } from "./DeleteExtraServiceDialog"

const useStyles = makeStyles()(() => ({
    deleteItem: {
        color: tailwindPalette.red[600],
    },
}))

type RenderRowActionMenuItemsProps = {
    row: MRT_Row<ExternalServiceEntry>
    closeMenu: () => void
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
    navigate: (path: string) => void
}

const RowActionMenuItems = ({ row, closeMenu, setConfirmModalState, navigate }: RenderRowActionMenuItemsProps) => {
    const { classes } = useStyles()

    return [
        <LocalizedStrict id="products-edit-product-menu-item" key={`edit-${row.original.id}`}>
            <MenuItem
                onClick={() => {
                    navigate(getExtraServiceRoute(row.original.id))
                    closeMenu()
                }}
            >
                Edit
            </MenuItem>
        </LocalizedStrict>,
        <LocalizedStrict id="products-delete-product-menu-item" key={`delete-${row.original.id}`}>
            <MenuItem
                className={classes.deleteItem}
                onClick={() => {
                    setConfirmModalState({
                        showConfirmModal: true,
                        confirmModalText: `${row.original.name}`,
                        productId: row.original.id,
                    })
                    closeMenu()
                }}
            >
                Delete
            </MenuItem>
        </LocalizedStrict>,
    ]
}

export const renderRowActionMenuItems = (props: RenderRowActionMenuItemsProps) => RowActionMenuItems(props)
